import { Decimal as PBDecimal } from "gen/proto/decimal/models_pb"
import { Decimal } from "shared-ts/classes/decimal"

import { data } from "./data"
import { TypedAccessor } from "./types"
import { TableCellWidth } from "../TableCell"
import { DataColumn } from "../useTable/types"

type PercentAccessorFn<T> = TypedAccessor<
  T,
  number | PBDecimal | Decimal | undefined
>
interface PercentColumn<T>
  extends Omit<DataColumn<T>, "type" | "renderCell" | "width"> {
  width?: DataColumn<T>["width"]
  decimalPlaces?: number
}
export type PercentColumnHelper<T> = (
  accessorFn: PercentAccessorFn<T>,
  col: PercentColumn<T>
) => DataColumn<T>

export function percent<T>(
  accessorFn: PercentAccessorFn<T>,
  col: PercentColumn<T>
): DataColumn<T> {
  const { width, decimalPlaces = 1, ...otherCol } = col
  return data({
    renderCell: (rowData) => {
      const value = accessorFn(rowData)
      if (value === undefined) return null
      if (typeof value === "number") {
        const percent = value * 100
        return `${percent.toFixed(decimalPlaces)}%`
      }
      if (PBDecimal.is(value)) {
        return Decimal.fromPB(value).toPercentString(decimalPlaces)
      }
      return null
    },
    width: width ?? TableCellWidth.Small,
    ...otherCol,
  })
}
